import React from 'react';
import { Field, RadioGroup, CreatableDropdown } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let MaterialBrokenUpSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isBrokenUpBeforeSieving = useSelector(
    pipe(createWorksheetSelector!('Sieving.IsBrokenUpBeforeSieving'), valueOrDefault(false))
  );

  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Material Broken Up Prior to Sieving"
        name="Sieving.IsBrokenUpBeforeSieving"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
      />

      <Field
        input={<CreatableDropdown />}
        label="Material Broken Up by"
        name="Sieving.BrokenUpBy"
        formatCreateLabel={(label: string) => `Other: ${label}`}
        simpleValue
        maxLength={50}
        visible={isBrokenUpBeforeSieving}
        options={['Mortar & Pestle', 'Pulverizer', 'Hand'].map((v) => ({ label: v, value: v }))}
      />
    </ListFieldSection>
  );
};

MaterialBrokenUpSection = withInjectedProps(MaterialBrokenUpSection);

export { MaterialBrokenUpSection };
export default MaterialBrokenUpSection;
